export const resourceKeys = {
  all: ["resources"] as const,
  resource: (resourceId: string | undefined) => [...resourceKeys.all, resourceId, "resource"] as const,
};
